<script>
    export default {
        methods: {
            close() {
                this.$store.commit('closeModal');
            },
        }
    }
</script>

<template>
    <Teleport to="body">
        <Transition name="modal-fade">
            <div v-if="$store.getters.getModalComponent" class="modal is-active" role="dialog" tabindex="-1">
                <div class="modal-background" @click.self="close"></div>
                <div class="modal-card">
                    <component :is="$store.getters.getModalComponent" v-bind="$store.getters.getModalProps" />
                </div>
            </div>
        </Transition>
    </Teleport>
</template>
